export default {
  heading: {
    widgetName: "Shopping Product Widget",
    widgetID: "107",
    cardCount: "5",
    headlineType: "h2",
    widgetWidth: '3',
    layoutName: "lob_widget",
    headline: "ช้อปสินค้าโปรดโดนใจ",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `shop | SHOP Favourites`,
      eventLabelCardClick: `shop | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `shop | headline | {{headline}}`,
      eventLabelView: `shop | SHOP Favourites`,
    },
  },

	data: [{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: '960 บาท',
			formattedPriceWeb: '960 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_1-Mt-Sapola.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'เซ็ตน้ำมันอโรม่า',
			title: 'เมาท์ เซโพลา',
			url: 'https://www.airasia.com/shop/th/th/product/mt-sapola-inflight-harikul-group-co-ltd/paper-box-with-4x65ml-massage-oils?type_id=2'
		},
		{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '590 บาท',
			formattedOriginalPriceWeb: '590 บาท',
			formattedPriceMob: '390 บาท',
			formattedPriceWeb: '390 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_2-vitanatureplus.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'ผลิตภัณฑ์เสริมอาหาร ไบโอติน ซิงค์ ผสมสารสกัดหญ้าหางม้า 30 แคปซูล',
			title: 'ไวตาเนเจอร์พลัส',
			url: 'https://www.airasia.com/shop/th/th/product/rs-livewell-co-ltd-inflight/vitanature-biotin-zinc-with-horsetail-extract-30-capsules?type_id=2'
		},
		{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: '420 บาท',
			formattedPriceWeb: '420 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_3-Maithong.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'ไหมทอง กี๊ฟเซทมินิโซป',
			title: 'ไหมทอง',
			url: 'https://www.airasia.com/shop/th/th/product/maithong-inflight-p-and-t-siam-co-ltd/maithong-mini-natural-soap-collection-green-box?type_id=2'
		},
		{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: '120 บาท',
			formattedPriceWeb: '120 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_4-PHUTAWAN.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'น้ำมันมะพร้าวสกัดเย็น 100%',
			title: 'ภูตะวัน',
			url: 'https://www.airasia.com/shop/th/th/product/phutawan-herb-and-cosmetic-co-ltd-inflight/virgin-coconut-oil-100-ml?type_id=2'
		},
		{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '600 บาท',
			formattedOriginalPriceWeb: '600 บาท',
			formattedPriceMob: '390 บาท',
			formattedPriceWeb: '390 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_5-REJU.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'เครื่องดื่มรังนกแท้สำเร็จรูป สูตรคลาสสิค 45 มล. แพ็ค 6 ขวด',
			title: 'รีจู',
			url: 'https://www.airasia.com/shop/th/th/product/rs-livewell-co-ltd-inflight/reju-real-birds-nest-beverage-classic-formula-45-ml-x-6-bottles?type_id=2'
		},
		{
			cta: 'หยิบใส่ตะกร้า',
			currencyCode: 'THB',
			discount: '',
			formattedOriginalPriceMob: '',
			formattedOriginalPriceWeb: '',
			formattedPriceMob: '190 บาท',
			formattedPriceWeb: '190 บาท',
			hidden: '',
			image: 'https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/SKU_6-ChaobanMarket.png',
			newTab: 'TRUE',
			colorButton: 'neutral',
			originalprice: '',
			position: '',
			price: '60',
			priceDisclaimer: '',
			primaryLabel: '',
			productID: '',
			productType: 'button',
			rating: '',
			showOverlayBackGround: false,
			subtitle: 'กางเกงช้างขนาดฟรีไซส์ เนื้อผ้าอย่างดี (สีแดง)',
			title: 'ชาวบ้าน ล้านตลาด',
			url: 'https://www.airasia.com/shop/th/th/product/use-network-company-limited-inflight/premium-quality-elephant-printed-pants-free-size-red?type_id=2'
		}
	]
}